import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { HideMobileFooterDirective, HideMobileNav } from '@fgb/portal-component-library/src/lib/directives';
import { FacialRecognitionValidatingPhotoComponent } from '../facial-recognition-validating-photo/facial-recognition-validating-photo.component';

@Component({
  selector: 'fgb-facial-recognition-image-uploader',
  templateUrl: './facial-recognition-image-uploader.component.html',
  styleUrl: './facial-recognition-image-uploader.component.scss',
  hostDirectives: [HideMobileNav, HideMobileFooterDirective],
})
export class FacialRecognitionImageUploaderComponent implements OnInit {
  @Input() uploadedImage: FormControl = new FormControl();
  @Input() formData: FormControl = new FormControl();
  @Input() isUploadInfo: boolean = false;
  @Input() goToStep: number = 1;
  stepCounter = 1;

  @ViewChild('validatingPhoto') validatingPhoto!: FacialRecognitionValidatingPhotoComponent;

  ngOnInit(): void {
    if (this.goToStep) {
      this.setStep(this.goToStep);
    }
  }

  validatePhoto() {
    this.validatingPhoto.validationCheck();
  }

  nextStep() {
    this.stepCounter++;
  }

  prevStep() {
    this.stepCounter--;
  }

  setStep(step: number) {
    this.stepCounter = step;
  }
}
